import * as types from '../../index';

export const aflt_mRateCardListAction = (data) => {
    return {
    type: types.MASTER_RATE_CARD_LIST_AFFILIATE,
    data
    }
};

export const aflt_mRateCardUpdateAction = (data) => { 
    return {
    type: types.MASTER_RATE_CARD_UPDATE_AFFILIATE,
    data
    }
};

export const getAffiliateChiefBonusAction = (data) => {  
    return {
    type: types.GET_AFFILIATE_CHEIF_BONUS,
    data
    }
};

export const updateAffiliateChiefBonusAction = (data) => { 
    return {
    type: types.UPDATE_AFFILIATE_CHEIF_BONUS,
    data
    }
};

export const getRateCardChiefBonusAction = (data) => {  
    return {
    type: types.RATECARD_CHEIF_BONUS_GET,
    data
    }
};

export const updateRateCardChiefBonusAction = (data) => { 
    return {
    type: types.RATECARD_CHEIF_BONUS_UPDATE,
    data
    }
};

export const CopyMasterCardToClient = (data) => { 
    return {
    type: types.COPY_MASTER_CARD_TO_CLIENT,
    data
    }
};
export const CopyCategoryToCategory = (data) => { 
    return {
    type: types.COPY_CATEGORY_TO_CATEGORY,
    data
    }
};

export const rateCardListAction = (data) => { 
    return {
    type: types.RATE_CARD_LIST,
    data
    }
};

export const rateCardUpdateAction = (data) => { 
    return {
    type: types.RATE_CARD_UPDATE,
    data
    }
};

// TO APPEND RATE CARD NAME WITH PAGE TITLE WHILE CHANGING RATE CARD FROM DROP-DOWN 
export const setRateCardNamePageSubTitle = (data) => { 
    return {
    type: types.SET_RATE_CARD_SUBTITLE,
    data
    }
};

